import TableCell from '@tiptap/extension-table-cell';

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      customStyle: {
        default: null,
        renderHTML: () => {
          return {
            style:
              'min-width: 48px; border: 2px solid #ced4da; padding: 3px 5px; vertical-align: top; box-sizing: border-box; position: relative;',
          };
        },
      },
    };
  },
});
